import React, { useState } from "react";
import {
  Container,
  Header,
  TableContainer,
  TableHeader,
  TableBody,
  Pagination,
} from "./Component copy/TableComponent/Table";
import { LinkUnit } from "./Component copy/Utils/Utils";
import BulkExport from "./Component copy/BulkButton/BulkExport";
import BulkImport from "./Component copy/BulkButton/BulkImport";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { FaPlus } from "react-icons/fa";
import SearchPopup from "../Popup/SearchPopup";

function CreateUnitModalPop({ isOpen, setIsOpen }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <div className="bg-white rounded-md shadow-lg w-[600px] relative">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold"> Add Link Unit to SAC</h2>
            <button
              onClick={() => setIsOpen(false)}
              className="text-gray-500 text-xl font-bold"
            >
              &times;
            </button>
          </div>

          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">
                SAC<span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                placeholder="Enter Unit"
                className="w-full border border-gray-300 outline-none rounded-md px-3 py-2 "
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                Default Unit<span className="text-red-500">*</span>
              </label>

              
              <input
                type="text"
                placeholder="Enter Unit"
                className="w-full border outline-none border-gray-300 rounded-md px-3 py-2  "
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">
                Other Allowed Unit <span className="text-red-500">*</span>
              </label>
              <textarea
                placeholder="Description about Other ALlowed Unit ...use (,) For Multiple"
                className="w-full border border-gray-300 rounded-md px-3 py-2 h-28 resize-none outline-none"
              ></textarea>
            </div>

            <div className="text-right">
              <button
                onClick={() => setIsOpen(false)}
                className="bg-[#009FE3] text-white px-6 py-2 rounded hover:bg-[#0083be]"
              >
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

// Table Component
function TrendingTable() {
  const RowHeader = ["Unit", "Define Unit","Other Allowed Unit", "Action"];

  return (
    <Container>
      <Header>
        <TableContainer>
          <TableHeader children={RowHeader} />
          <TableBody rows={LinkUnit} />
        </TableContainer>
      </Header>
    </Container>
  );
}

// Main Component
export const LinkUnitToHSN = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="mt-10">
      <ReactTooltip
        id="main-tooltip"
        place="top"
        effect="solid"
        className="!text-[14px] !rounded-md !px-2 !py-[2px] !text-white z-20 shadow-md"
      />

      <div className="flex justify-between">
        {/* Left section */}
        <div className="flex w-full justify-start items-center gap-3">
          <p className="text-xl text-gray-500 font-semibold">
            Link Unit to SAC
          </p>

          <button
        onClick={() => setShowModal(true)}
        data-tooltip-id="main-tooltip"
        data-tooltip-content="Create"
        className="text-sm shadow-sm font-semibold rounded-md px-6 py-2 flex gap-2 items-center 
        justify-center text-center transition-all bg-red-600 text-white hover:bg-red-700"
      >
        <FaPlus size={18} />
        Add Link Unit
      </button>

      {showModal && (
        <SearchPopup
          isOpen={showModal}
          onClose={() => setShowModal(false)}
        />
      )}

          {/* Modal */}
         
        </div>

        {/* Right section */}
        <div className="flex w-full gap-2 justify-end">
          <BulkImport content={"Import Link"} />
          <BulkExport content="Export Link" />
          <Pagination />
        </div>
      </div>

      <TrendingTable />
    </div>
  );
};
